import { z } from 'zod';

/**
 * The complete-failure-list envelope (Behavioural convention §1.2). Domain
 * validators accumulate ALL failures and return them in one 422 response —
 * never fail-fast on the first violation.
 */

export const DomainErrorSchema = z.object({
  /** Stable machine-readable code, e.g. 'ROLE_NAME_TAKEN'. */
  code: z.string(),
  message: z.string(),
  /** Optional pointer into the request body, e.g. ['departmentId']. */
  path: z.array(z.string()).optional(),
});

export type DomainError = z.infer<typeof DomainErrorSchema>;

export const DomainErrorsResponseSchema = z.object({
  statusCode: z.literal(422),
  errors: z.array(DomainErrorSchema),
});

export type DomainErrorsResponse = z.infer<typeof DomainErrorsResponseSchema>;
